export default "__VITE_ASSET__CyfKgWWU__"